import { render, staticRenderFns } from "./Plugin-info.vue?vue&type=template&id=424e240e&scoped=true&"
import script from "./Plugin-info.vue?vue&type=script&lang=js&"
export * from "./Plugin-info.vue?vue&type=script&lang=js&"
import style0 from "./Plugin-info.vue?vue&type=style&index=0&id=424e240e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e240e",
  null
  
)

export default component.exports